import { render, staticRenderFns } from "./EnrollmentsEdit.vue?vue&type=template&id=711c4a44"
import script from "./EnrollmentsEdit.vue?vue&type=script&lang=js"
export * from "./EnrollmentsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports